{
    "tools": "Tool",
    "exportPage": "Export Page",
    "importPage": "Import Page",
    "managePage": "Manage Page",
    "mdsPage": "Multi Data Sources",
    "mdsAllTitle": "All Multi Data Sources",
    "mdsNewTitle": "New Multi Data Source",
    "mdsRefresh": "Refresh",
    "mdsCreate": "Create",
    "mdsSave": "Save",
    "mdsColumnLongName": "Long Name",
    "mdsColumnShortName": "Short Name",
    "mdsColumnUpdated": "Last Updated",
    "mdsColumnDescription": "Description",
    "mdsFieldLongName": "Long Name",
    "mdsFieldShortName": "Short Name",
    "mdsFieldDescription": "Description",
    "mdsFieldSources": "Data sources",
    "mdsNoMultiDatasources": "There are no multi data sources for this client",
    "mdsNoSources": "There are no datasources available",
    "mdsNameInvalid": "Data source names must begin with a letter and may only contain letters, numbers and the underscore character",
    "mdsDuplicateName": "A data source with this name already exists, please choose a different name",
    "mdsShortNameRequired": "Short Name is required",
    "mdsNoDsSelected": "You must select one or more datasources to be linked",
    "mdsConfirmSave": "The data source has been saved successfully",
    "mdsUnknownError": "Unknown error returned from server",
    "mdsCopy": "Copy",
    "mdsAttach": "Attach",
    "mdsDelete": "Delete",
    "mdsCancel": "Cancel",
    "mdsOk": "OK",
    "mdsCopySelectOne": "Select the multi data source you would like to duplicate",
    "mdsColumnMultiDs": "Multi data source",
    "mdsAttachTitle": "Attach an existing multi data source",
    "mdsAttachComment": "Select multi data sources below to attach them to your client",
    "mdsAttachNoSources": "There are no other multi data sources defined that can be attached to your client",
    "mdsAttachSaved": "The multi data sources attached to this client have been updated",
    "mdsQuestionDelete": "Are you sure you would like to delete this data source?",
    "mdsHasFilters": "This data source has {count} filter or attribute version(s) coded for it and cannot be deleted. Delete or recode them first.",
    "mdsConfirmDelete": "The data source has been deleted successfully",
    "reportsPage": "Reports Page",
    "dashboard": "Dashboard",
    "dlient": "Client",
    "clientSummary": "View currently selected client summary information and/or launch another client",
    "systems": "Systems",
    "systemSummary":"Sub-sets of attributes logically organized into groups supporting deployment and tools management",
    "sttributes": "Attributes",
    "attributesSummary":"Leveled characteristics derived from one or more filters and/or attributes and used in one or more systems",
    "filters": "Filters",
    "filtersSummary": "Normalized components of attributes derived from one or more raw data and/or filters and used in one or more attributes",
    "toolsSummary": "  Group of ATB management features including Import, Export, Report and Multi Data Source",
    "clientSelection": "Client Selection",
    "clientSelectionDescription": "Please select the client you would like to use from those available below :",
    "clientList": "Client List:"
}